import React from 'react';
import Reviews from '../../containers/Reviews/Reviews';

const ReviewsPage = () => {
  return <Reviews />;
};

export default ReviewsPage;
